import { useFeatureFlagEnabled } from "posthog-js/react";

import { useAccount } from "@/hooks";

const REACT_ENV = import.meta.env.VITE_REACT_ENV;

export function useCanSelectPanel() {
  const { account } = useAccount();
  const email = account?.email || "";

  const isCanSelectPanel = useFeatureFlagEnabled(
    "canSelectPanel",
  );

  return (
    isCanSelectPanel ||
    (["dev", "dojo"].includes(REACT_ENV) && email.endsWith("@mylot.ai"))
  );
}
